import { required } from 'vuelidate/lib/validators'

export default {
    validations: {
        user: {
            first_name: {
                required,
            },
            tax_number: {
                required,
            },
            street: {
                required,
            },
            city: {
                required,
            },
            state: {
                required,
            },
            country_id: {
                required,
            },
        },
        selectedCurrency: {
            required,
        },
    },

    computed: {
        firstNameErrors() {
            let errors = ''

            if (!this.$v.user.first_name.$dirty) {
                return errors
            }

            if (!this.$v.user.first_name.required)
                errors = errors.concat(this.$t('validations.name_is_required'))

            return errors
        },

        taxNumberErrors() {
            let errors = ''

            if (!this.$v.user.tax_number.$dirty) {
                return errors
            }

            if (!this.$v.user.tax_number.required)
                errors = errors.concat(
                    this.$t('validations.tax_number_is_required')
                )

            return errors
        },

        streetErrors() {
            let errors = ''

            if (!this.$v.user.street.$dirty) {
                return errors
            }

            if (!this.$v.user.street.required)
                errors = errors.concat(
                    this.$t('validations.street_is_required')
                )

            return errors
        },

        cityErrors() {
            let errors = ''

            if (!this.$v.user.city.$dirty) {
                return errors
            }

            if (!this.$v.user.city.required)
                errors = errors.concat(this.$t('validations.city_is_required'))

            return errors
        },

        stateErrors() {
            let errors = ''

            if (!this.$v.user.state.$dirty) {
                return errors
            }

            if (!this.$v.user.state.required)
                errors = errors.concat(this.$t('validations.state_is_required'))

            return errors
        },

        countryErrors() {
            let errors = ''

            if (!this.$v.user.country_id.$dirty) {
                return errors
            }

            if (!this.$v.user.country_id.required) {
                errors = errors.concat(
                    this.$t('validations.country_is_required')
                )
            }

            return errors
        },

        currencyErrors() {
            let errors = ''

            if (!this.$v.selectedCurrency.$dirty) {
                return errors
            }

            if (!this.$v.selectedCurrency.required)
                errors = errors.concat(
                    this.$t('validations.currency_is_required')
                )

            return errors
        },
    },
}
